module.exports = __webpack_public_path__ + "static/media/att.19pAbM3x6j-Q_dHNIxvWWpXdv5wSkWK_nFWTcGLlAb4.e7dc0aef.jpg";